import React from 'react';
import { FormGrid } from '@packages/ui/patterns';
import type { FormGridNode } from '../../types/layout';
import { FormNodeRenderer } from '../FormNodeRenderer';

interface GridRendererProps {
  node: FormGridNode;
  namePrefix?: string;
}

export const FormGridRenderer = React.memo(function FormGridRenderer({ node, namePrefix }: GridRendererProps): React.ReactElement {
  const columns = typeof node.columns === 'number' || typeof node.columns === 'string'
    ? node.columns
    : (node.columns ?? 2);

  return (
    <FormGrid columns={columns} gap={node.gap} semanticId={node.semanticId}>
      {node.children.map((child, idx) => (
        <FormGrid.Item key={idx} colSpan={child.colSpan}>
          <FormNodeRenderer node={child} namePrefix={namePrefix} />
        </FormGrid.Item>
      ))}
    </FormGrid>
  );
});
